import React from 'react';
import { useViewerCount } from '../hooks/useViewerCount';
export function UrgencyBadges() {
  const viewerCount = useViewerCount();
  return <div className="max-w-[500px] mx-auto mt-6 mb-2.5 flex flex-col gap-3" data-id="element-262">
      <div className="text-white font-bold p-3 rounded-lg text-base text-center shadow-[0_4px_10px_rgba(0,0,0,0.05)] bg-black shadow-[0_0_15px_rgba(0,0,0,0.5),inset_0_0_5px_rgba(255,255,255,0.1)]" data-id="element-263">
        <strong data-id="element-264">
          <span className="viewer-count" data-id="element-265">{viewerCount}</span> personas
        </strong>{' '}
        están viendo esta oferta
      </div>

      <div className="text-white font-bold p-3 rounded-lg text-base text-center shadow-[0_0_20px_rgba(255,50,50,0.4),inset_0_0_10px_rgba(255,100,100,0.3)] bg-gradient-to-br from-[#a50000] to-[#d11a2a] flex items-center justify-center gap-2.5" data-id="element-266">
        <span className="w-3 h-3 bg-white rounded-full animate-pulse-red" data-id="element-267"></span>
        <span data-id="element-268">
          ¡Últimos <strong data-id="element-269">7 Cupos</strong> con Descuento!
        </span>
      </div>
    </div>;
}